import { urlPatternWithoutHttpPrefix } from "./regularExpressions"

export const enterpriseWebsiteValidationMessage = "Enterprise web URL must be valid"

const protocolPattern = /^(http:\/\/|https:\/\/)/

export const isEnterpriseWebsiteValid = (value: string) => !value || urlPatternWithoutHttpPrefix.test(value)

export const getEnterpriseWebsiteValidationError = (value: string) =>
  value.trim() && !isEnterpriseWebsiteValid(value) ? enterpriseWebsiteValidationMessage : ""

export const normalizeEnterpriseWebsiteUrl = (value?: string) => {
  const trimmed = value?.trim()

  if (!trimmed) return ""

  return urlPatternWithoutHttpPrefix.test(trimmed) && !protocolPattern.test(trimmed) ? `https://${trimmed}` : trimmed
}
